import {
  login, //登录
  loginout, // 退出登录
  customer, //用户列表
  saveCustomer, //保存客户
  getOne, //获得客户详情
  news, //消息列表
  updateMessageRead, //消息已读
  updateMessageDelete, //删除消息
  updateMessageReadAll, //消息全部已读
  cashDetails, //子账号列表
  updateMemberStatus, //账号启用禁用
  balanceDistribution, //提交编辑
  findAllSubAccount, //获得昂前账号的子账号
  allocationDetails, //余额分配明细
  getTransactionType, //类型
  getAccountInfo,//个人信息
  changePasswordByOriginalPassword,//修改密码
  getCust,//获取用户信息
  getCustBalance,//余额
  getMemberAuthority,//权限
  importCustomerCsv,//导入客户CSV
} from "@/api/user.js";
import {
  Message
} from 'view-design';

import {
  getToken,
  setToken,
  removeToken,
  getMenu,
  setMenu
} from "@/libs/util";
import router from '../../router/index'
export default {
  state: {

    login: Boolean(getToken()) || false,
    // menu:getMenu()||[]
    //   customer: {}
  },
  actions: {
    // 登录保存token
    loginAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        login(params)
          .then(res => {
            commit("SETTOKENS", res.data.data); // 此处更改成自己需要的值
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 退出登录
    loginoutAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        loginout(params)
          .then(res => {
            commit('LOGOUT')
            if(res.data.code === 0){
              Message.success(res.data.message)
            }else{
              Message.error(res.data.message)
            }
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 用户列表
    customerAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        customer(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 用户余额
    getCustBalanceAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getCustBalance(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 菜单权限
    getMemberAuthorityAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getMemberAuthority(params)
          .then(res => {
            resolve(res.data);
            commit('SETMENUS',res.data)
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取用户信息
    getCustAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getCust(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 修改密码
    changePasswordByOriginalPasswordAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        changePasswordByOriginalPassword(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 个人信息
    getAccountInfoAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getAccountInfo(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 类型
    getTransactionTypeAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getTransactionType(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 余额分配明细
    allocationDetailsAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        allocationDetails(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获得当前子账号
    findAllSubAccountAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        findAllSubAccount(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 提交编辑
    balanceDistributionAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        balanceDistribution(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 账号启用禁用
    updateMemberStatusAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        updateMemberStatus(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 子账号列表
    cashDetailsAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        cashDetails(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 消息全部已读
    updateMessageReadAllAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        updateMessageReadAll(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 删除消息
    updateMessageDeleteAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        updateMessageDelete(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 用户已读
    updateMessageReadAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        updateMessageRead(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 消息列表
    newsAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        news(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 客户详情
    getOneAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getOne(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 保存用户
    saveCustomerAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        saveCustomer(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 导入客户CSV
    importCustomerCsvAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        importCustomerCsv(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 登出清空数据
    logoutAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        commit('LOGOUT')

      });
    },
    // 登出清空数据
    logoutNoIndexAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        commit('LOGOUTNOINDEX')
      });
    }
  },
  mutations: {
    // 存储token
    SETTOKENS(state, token) {
      setToken(token);
      state.login = true
      
      // 检查是否有重定向地址
      const redirect = router.currentRoute.query.redirect;
      if (redirect && redirect !== '/') {
        // 清除当前URL中的redirect参数
        const currentQuery = { ...router.currentRoute.query };
        delete currentQuery.redirect;
        
        // 延迟一下确保状态更新完成
        setTimeout(() => {
          // 先更新当前路由移除redirect参数
          router.replace({
            path: router.currentRoute.path,
            query: currentQuery
          }).then(() => {
            // 然后跳转到目标页面
            router.push(redirect);
          });
        }, 100);
      } else {
        router.go(0)
      }
    },
    // 存储token获取个人信息不刷新页面
    SETTOKEN(state, token) {
      setToken(token);
      state.login = true
    },
    // 设置菜单权限
    SETMENUS(state,menu) {
      setMenu(menu);
    },
    // 登出
    LOGOUT(state) {
      removeToken()
      state.login = false
      router.push('./')
    },
    LOGOUTNOINDEX(state) {
      removeToken()
      state.login = false
    },
    // 保存客户信息
    //   SETMEMBER(state, data) {
    //     localStorage.setItem('customer', JSON.stringify(data.data))
    //     state.customer = data.data
    //   }
  },
  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/module/user.js